import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { VelavuSite } from "velavu-js-api";
import IconAdd from "../../../../dynamicicons/icon-add";
import Divider from "../../../../elements/divider";
import VelavuButton from "../../../../elements/velavu-button";
import SiteSwitcherList from "../../../shared/site-switcher-list";
import * as styles from "./site-list.module.scss";
import IconSearch from "../../../../dynamicicons/icon-search";
import VelavuInput from "../../../../elements/velavu-input";
import whitelabel from "../../../../whitelabel";
import { useHasPermission } from "../../../sign-in-context/sign-in-context";

interface SiteListProps {
	sites: VelavuSite[];
	onSelectSite: (id: string) => void;
	onCreateSite: VoidFunction;
}

export default function SiteList(props: SiteListProps) {
	const { t } = useTranslation();

	const canWriteSites = useHasPermission("sites:write");

	const [searchText, setSearchText] = useState("");

	const sanitizedSearchText = useMemo(() => {
		return searchText.trim().toLowerCase();
	}, [searchText]);

	const filteredSites = useMemo(() => {
		if (sanitizedSearchText === "") {
			return props.sites;
		} else {
			return props.sites.filter((site) =>
				site.name.toLowerCase().includes(sanitizedSearchText),
			);
		}
	}, [props.sites, sanitizedSearchText]);

	return (
		<React.Fragment>
			<div className={styles.header}>
				<VelavuInput
					className={styles.search}
					leadingIcon={
						<IconSearch
							size={16}
							color={whitelabel.palette.secondary900}
						/>
					}
					placeholder={t("dashboard.site_list.search_sites")}
					value={searchText}
					onChange={setSearchText}
					fullWidth
				/>

				{canWriteSites && (
					<VelavuButton
						icon={(size, color, className) => (
							<IconAdd
								size={size}
								color={color}
								className={className}
							/>
						)}
						label={t("dashboard.site_list.new_site")}
						onClick={props.onCreateSite}
					/>
				)}
			</div>

			<Divider />

			<SiteSwitcherList
				className={styles.list}
				sites={filteredSites}
				onSelectSite={props.onSelectSite}
			/>
		</React.Fragment>
	);
}
